import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ComponentCanDeactivate } from '../guards/pending-changes.guard';
import { NotificationsService } from 'angular2-notifications';
import { Patient } from '../models/index';
import { Api, Session, States } from '../services/index';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import * as _ from 'lodash';
import { MyModal } from '../components/modal/modal';
import { PaymentMethod, PaymentMethodResult } from '../models/sf-payments'
import { calcBindingFlags } from '@angular/core/src/view/util';
import { _MatChipListMixinBase } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-my-profile',
  templateUrl: './dashboard-my-profile.html',
  styleUrls: ['./dashboard-my-profile.css']
})

export class DashboardMyProfileComponent implements OnInit, ComponentCanDeactivate {
  avatar: string = '../../assets/images/ico-profile.png';

  filesToUpload: Array<File> = [];
  fileTypes = 'image/png image/jpeg image/gif';
  isGUID: boolean = false;
  orgPatient: Patient = new Patient;
  patient: Patient = new Patient;
  patientFormGroup: FormGroup;
  patientPreferenceGroup: FormGroup;
  preferredPaymentMethodId: number;
  paymentMethods: Array<PaymentMethodResult> = [];
  loading: Boolean = false;
  cardToEdit: PaymentMethodResult;
  is18Valid: boolean = false;
  public headerText: Object = [{ text: "Profile", 'iconCss': 'e-profile' },
  { text: "Preferences", 'iconCss': 'e-pref' }, { text: "Payments", 'iconCss': 'e-pay' }];
  public GenderSelect: Object = [{ text: "Male", 'value': 'M' }, { text: "Female", 'value': 'F' }, { text: "Other", 'value': 'O' }];
  public genderFields: Object = { text: 'text', value: 'value' };
  public stateFields: Object = { text: 'name', value: 'abbreviation' };
  stateList: any[];
  animationSettings: string = '';
  patientBirthDate: string;

  @ViewChild('listviewInstance')
  public listviewInstance: any;

  public lvheaderTitle: string = '';
  public cssClass: string = 'e-list-template';

  constructor(private api: Api,
    private fb: FormBuilder,
    private router: Router,
    private translateService: TranslateService,
    private service: NotificationsService,
    private session: Session,
    private states: States) {

    this.patient = new Patient();
    this.patientBirthDate = '01/01/1900';


    this.patientFormGroup = this.fb.group({
      'gender': new FormControl(this.patient.profile.gender, [Validators.required, Validators.pattern(/^[MF]+$/i)]),
      'loginEmail': new FormControl(this.patient.email, Validators.required),
      'firstName': new FormControl(this.patient.profile.firstName, Validators.required),
      'lastName': new FormControl(this.patient.profile.lastName, Validators.required),
      'dob': new FormControl(this.patientBirthDate),
      'address1': new FormControl(this.patient.profile.address1, Validators.required),
      'city': new FormControl(this.patient.profile.city, Validators.required),
      'state': new FormControl(this.patient.profile.state, Validators.required),
      'zipCode': new FormControl(this.patient.profile.zipCode, [Validators.required, Validators.minLength(5)]),
      'phoneNumber': new FormControl(
        this.patient.phoneNumber,
        Validators.compose([
          Validators.minLength(10),
          Validators.maxLength(14),
          Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
        ]))
    });



    this.patientPreferenceGroup = this.fb.group({
      'contactEmail': new FormControl(this.patient.preferences.contactEmail, [this.emailOrEmpty]),
      'contactPhoneNumber': new FormControl(
        this.patient.preferences.contactPhoneNumber,
        Validators.compose([
          Validators.minLength(10),
          Validators.maxLength(14),
          Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
        ]))
    });


  }

  getSession() {
    return this.session;
  }
  //Focus Event function for input component
  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  //FocusOut Event function for input component
  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }

  //Focus Event function for input component
  public focusInLeft(target: HTMLElement): void {
    target.parentElement.parentElement.classList.add('e-input-focus');
  }

  //FocusOut Event function for input component
  public focusOutLeft(target: HTMLElement): void {
    target.parentElement.parentElement.classList.remove('e-input-focus');
  }

  //MouseDown Event function for input component
  public onMouseDown(target: HTMLElement): void {
    target.classList.add('e-input-btn-ripple');
  }

  //MouseUp Event function for input component
  public onMouseUp(target: HTMLElement): void {
    let ele: HTMLElement = target;
    setTimeout(
      () => { ele.classList.remove('e-input-btn-ripple'); },
      500);
  }
  isUUID(s: string) {
    let uuid: boolean;
    let regexPattern = new RegExp('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
    uuid = regexPattern.test(s);
    this.isGUID = uuid;
    // this.changeDetectorRef.detectChanges();
    //if (!this.changeDetectorRef['destroyed']) {
    //  this.changeDetectorRef.detectChanges();
    //}
    return uuid;
  }

  dateValidator(control: FormGroup) {
    if (control.controls.month.value && control.controls.day.value && control.controls.year.value) {
      let value = control.controls.month.value + '/' + control.controls.day.value + '/' + control.controls.year.value;
      if (value && value.length > 0) {
        let birthday: string = value;
        let age: number;

        let regex, today, birthDate, month;
        regex = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; //if no pattern provided
        if (!regex.test(birthday)) {
          return { 'invalidBirthday': true };
        }

        if (!age) {
          today = new Date();
          birthDate = new Date(birthday);
          age = today.getFullYear() - birthDate.getFullYear();
          month = today.getMonth() - birthDate.getMonth();
          if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age = age - 1;
          }
        }

        if (isNaN(age)) {
          age = -1;  //if age is invalid
        }

        if (age === -1) {
          return { 'invalidBirthday': true };
        }
      }
    }
  }

  emailOrEmpty(control: AbstractControl): ValidationErrors {
    if (!control.value) {
      return null;
    }

    return Validators.email(control);
  }

  dateUnder18Validator(value: any) {


    if (value) {
      // let birthday: string = value;
      let age: number;

      // let regex, today, birthDate, month;
      // regex = /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/; //if no pattern provided
      // if (!regex.test(birthday)) {
      //   return true;
      // }

      if (!age) {
        let today = new Date();
        let birthDate = new Date(value);
        let age = today.getFullYear() - birthDate.getFullYear();
        let month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
          age = age - 1;
        }
      }

      if (isNaN(age)) {
        age = -1;  //if age is invalid
      }

      if (age === -1) {
        return true;
      }

      if (age < 18) {
        return true;
      }

      return false;
    }


    return false;
  }

  onBirthdayValueChanged(value: any) {
    let contactEmailControl = this.patientPreferenceGroup.get('contactEmail');
    // Using setValidators to add and remove validators. No better support for adding and removing validators to controller atm.
    // See issue: https://github.com/angular/angular/issues/10567

    let validator = this.dateUnder18Validator(value);

    if (validator) {
      contactEmailControl.setValidators([this.emailOrEmpty]);
    } else {
      contactEmailControl.setValidators([this.emailOrEmpty, Validators.required]);
    }

    contactEmailControl.updateValueAndValidity(); //Need to call this to trigger a update
  }

  get address1() { return this.patientFormGroup.get('address1'); }
  get city() { return this.patientFormGroup.get('city'); }
  get contactEmail() { return this.patientPreferenceGroup.get('contactEmail'); }
  get contactPhoneNumber() { return this.patientPreferenceGroup.get('contactPhoneNumber'); }
  get dateOfBirth() { return this.patientFormGroup.get('dob'); }
  get firstName() { return this.patientFormGroup.get('firstName'); }
  get gender() { return this.patientFormGroup.get('gender'); }
  get lastName() { return this.patientFormGroup.get('lastName'); }
  get patientNotes() { return this.patientFormGroup.get('patientNotes'); }
  get phoneNumber() { return this.patientFormGroup.get('phoneNumber'); }
  get state() { return this.patientFormGroup.get('state'); }
  get zipCode() { return this.patientFormGroup.get('zipCode'); }

  getStateList() {
    return this.session.stateList;
  }

  ngOnInit() {
    this.firstName.disable();
    this.lastName.disable();
    this.getPatient(this.session.patientId);
    this.stateList = this.getStateList();
    this.translateService.get('MY_PROFILE.SAVED_PAYMENTS').subscribe((res: string) => {
			if(res){
			  this.lvheaderTitle  = res;
			}else{
			  this.lvheaderTitle  = 'Saved Cards';
			}
			
			console.log(res);
      }); 
      this.translateService.get('MMODAL_ENTER_PAYMENT_INFORMATION').subscribe((res: string) => {
        if(res){
          this.animationSettings  = res;
        }else{
          this.animationSettings  = 'Enter Payment Information';
        }
        }); 

      if(this.session.selectedLang === 'en'){
        this.headerText  = [{ text: "Profile", 'iconCss': 'e-profile' },
        { text: "Preferences", 'iconCss': 'e-pref' }, { text: "Payments", 'iconCss': 'e-pay' }];
      }
      if(this.session.selectedLang === 'es'){
        this.headerText  = [{ text: "Perfil", 'iconCss': 'e-profile' },
        { text: "Preferencias", 'iconCss': 'e-pref' }, { text: "Pagos", 'iconCss': 'e-pay' }];
      }
       


    
  }

  getPatient(patientId) {
    this.loading = true;
    let patient = this.api.getPatientById(patientId);
    patient.subscribe(response => {
      this.patient = response;
      let tmpTime = moment(this.patient.profile.dateOfBirth, 'YYYY/MM/DD');
      let validator = this.isUnder18Validator(this.patient.profile.dateOfBirth);
      if (validator > 18) {
        this.is18Valid = true;
      }


      this.orgPatient = _.cloneDeep(this.patient);
      if (this.isUUID(this.patient.email)) {
        this.patient.email = '';
      }

      if (this.patient.avatar) {
        this.avatar = this.session.environment.settings.patientAvatarBucket + this.patient.avatar;
      } else if (this.patient.profile.gender.toUpperCase() == 'F') {
        this.avatar = '../../assets/images/patient-avatar-female.png';
      } else {
        this.avatar = '../../assets/images/patient-avatar-male.png';
      }

      this.paymentMethods = new Array<PaymentMethodResult>();
      this.preferredPaymentMethodId = 0;
      this.api.getuserPaymentMethods(response.userId).subscribe(payMethodsResult => {
        this.paymentMethods = payMethodsResult;
      });
      let bday = moment(this.patient.profile.dateOfBirth, 'YYYY/MM/DD');
      this.patientBirthDate = bday.format('MM/DD/YYYY');
      //let birthD = bday.to
      //this.patient.profile.dateOfBirth = bday;
      this.patientFormGroup = this.fb.group({
        'gender': new FormControl(this.patient.profile.gender, [Validators.required, Validators.pattern(/^[MF]+$/i)]),
        'loginEmail': new FormControl(this.patient.email, Validators.required),
        'firstName': new FormControl(this.patient.profile.firstName, Validators.required),
        'lastName': new FormControl(this.patient.profile.lastName, Validators.required),
        'dob': new FormControl(this.patientBirthDate),
        'address1': new FormControl(this.patient.profile.address1, Validators.required),
        'city': new FormControl(this.patient.profile.city, Validators.required),
        'state': new FormControl(this.patient.profile.state, Validators.required),
        'zipCode': new FormControl(this.patient.profile.zipCode, [Validators.required, Validators.minLength(5)]),
        'phoneNumber': new FormControl(
          this.patient.phoneNumber,
          Validators.compose([
            Validators.minLength(10),
            Validators.maxLength(14),
            Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
          ]))
      });

      this.patientPreferenceGroup = this.fb.group({
        'contactEmail': new FormControl(this.patient.preferences.contactEmail, [this.emailOrEmpty]),
        'contactPhoneNumber': new FormControl(
          this.patient.preferences.contactPhoneNumber,
          Validators.compose([
            Validators.minLength(10),
            Validators.maxLength(14),
            Validators.pattern(/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)
          ]))
      });
      this.loading = false;
    })
  }

  saveDemographics() {
    this.loading = true;
    let value = this.patientFormGroup.get('dob').value;
    this.patient.profile.dateOfBirth = new Date(value);
    this.patient.email = this.patientFormGroup.get('loginEmail').value;
    let patient = this.api.updatePatientProfile(this.patient.userId, this.patient);
    patient.subscribe(response => {
      this.patient = response;
      this.orgPatient = _.cloneDeep(response);
      if (this.filesToUpload.length > 0) {
        this.uploadAvatar();
      } else {
        this.router.navigate(['/dashboard']);
      }
      this.service.success('Save Successful');
      this.loading = false;
    }, (error) => {
      this.service.error('Patient Save Failed', 'There was an error while saving, contact MeMD Team');
      this.loading = false;
    })
  }

  saveProfile() {
    this.loading = true;
   let savedata = this.patient;
   savedata.preferences.contactEmail = this.patientPreferenceGroup.get('contactEmail').value;
   savedata.preferences.contactPhoneNumber = this.patientPreferenceGroup.get('contactPhoneNumber').value;
    let patient = this.api.updatePatientProfile(this.patient.userId, savedata);
    patient.subscribe(response => {

      this.service.success('Save Successful');
      this.loading = false;
    }, (error) => {
      this.service.error('Patient Save Failed', 'There was an error while saving, contact MeMD Team');
      this.loading = false;
    })
  }

  onChangeBirthdate(args: any) {
    let validator = this.isUnder18Validator(this.patientFormGroup.get('dob').value);
    if (validator > 18) {
      this.is18Valid = true;
    }
  }
  isUnder18Validator(value: Date): number {

    let age: number = 0;
    if (value) {

      let today = new Date();
      let birthDate = new Date(value);
      let age = today.getFullYear() - birthDate.getFullYear();
      let month = today.getMonth() - birthDate.getMonth();
      if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
        age = age - 1;
      }


      if (isNaN(age)) {
        age = -1;  //if age is invalid
      }else{
        return age;
      }




    }
    return age;


  }

  fileChangeEvent(fileInput: any) {
    if (this.fileTypes.indexOf(fileInput.target.files[0].type) >= 0) {
      this.filesToUpload = <Array<File>>fileInput.target.files;
    } else {
      $('#uploadFileInput').val('');
      alert('Only file types of JPG, JPEG, PNG, and GIF are allowed to be uploaded');
    }
  }

  uploadAvatar() {
    if (this.filesToUpload.length > 0) {
      this.loading = true;
      let file = this.filesToUpload[0];
      let createPatientAvatarRequest = this.api.createPatientAvatar(this.patient.userId, file);
      createPatientAvatarRequest.subscribe(avatar => {
        this.router.navigate(['/dashboard']);
        this.loading = false;
      }, err => {
        this.service.error('Avatar Save Failed', 'There was an error while saving, contact MeMD Team');
        this.loading = false;
      });
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm alert before navigating away
    if (JSON.stringify(this.patient) !== JSON.stringify(this.orgPatient)) {
      return false;
    }
    return true;
  }

  // @HostListener allows us to also guard against browser refresh, close, etc.
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (!this.canDeactivate()) {
      $event.returnValue = 'WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.';
    }
  }

  gotoDashboard() {
    this.router.navigate(['/dashboard']);
  }

  @ViewChild('modalPayments') public _modalPayments: MyModal;

  openPaymentsModal() {
    this.cardToEdit = new PaymentMethodResult();
    this._modalPayments.open();
  }

  updateCard(cardOptions: PaymentMethodResult) {
    this.cardToEdit = cardOptions;
    this._modalPayments.open();
  }

  deleteCard(cardOptions: PaymentMethodResult) {
    this.loading = true;

    let data = new PaymentMethod();
    data.active = false;
    data.ispreffered = false;

    this.api.updateUserPaymentMethods(cardOptions.cardid, data).subscribe(result => {
      this.api.getuserPaymentMethods(this.patient.userId).subscribe(payMethodsResult => {
        this.paymentMethods = payMethodsResult;
        this.loading = false;
      });
    });
  }

  savePreferedPayment(cardOptions: PaymentMethodResult) {
    this.loading = true;
    // let thisCB: HTMLInputElement = document.querySelector('#cbpreferred_' + cardOptions.cardid);

    if (cardOptions.ispreffered) {
      // thisCB.checked = true;
      this.service.error('Action Failed', 'You can not un-prefer a payment method');
      this.loading = false;
    } else {
      let data = new PaymentMethod();
      data.contactfirstname = cardOptions.cardholderfirstname;
      data.cardholderfirstname = cardOptions.cardholderfirstname;
      data.contactlastname = cardOptions.cardholderlastname;
      data.cardholderlastname = cardOptions.cardholderlastname;
      data.contactemail = this.patient.email;
      data.contactphone = this.patient.phoneNumber;
      data.cardnumber = cardOptions.cardnumber;
      data.cardexpirationmonth = cardOptions.cardexpirationmonth;
      data.cardexpirationyear = cardOptions.cardexpirationyear;
      data.billingzip = cardOptions.billingzip;
      data.ccv = cardOptions.ccv;
      data.active = true;
      data.ispreffered = true;
      this.api.updateUserPaymentMethods(cardOptions.cardid, data).subscribe(result => {
        this.paymentMethods = new Array<PaymentMethodResult>();
        this.preferredPaymentMethodId = 0;
        this.api.getuserPaymentMethods(this.patient.userId).subscribe(payMethodsResult => {
          this.paymentMethods = payMethodsResult;
          this.loading = false;
        });
      })
    }
  }

  cardSaved() {
    this.loading = true;
    this._modalPayments.close();
    this.api.getuserPaymentMethods(this.patient.userId).subscribe(payMethodsResult => {
      this.paymentMethods = payMethodsResult;
      this.loading = false;
    });
  }
  cancelSave() {
    this._modalPayments.close();
  }
}
